import Vue from "vue";
import Vuex from "vuex";
import orders from "./modules/orders";
import validations from "./modules/validations";
import snackbar from "./modules/snackbar";
import dialog from "./modules/dialog";
import createLogger from "../plugins/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    orders,
    validations,
    snackbar,
    dialog,
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
});

export default store;
